const DataFeedbacks = {
  feedbacks: [
    {
      number: 1,
      name: "Jasmin",
      lang: "SV",
      eng : "Great books for the little ones. My daughter loves and tweaking it. Good for the development and motor function.",
      other : "Fantastiska böcker för de små. Min dotter älskar och pyssla med den. Bra för utvecklingen och motoriken.",
      location : "Sweden"
    },
    {
      number: 2,
      name: "Svetlana",
      lang: "RU",
      eng : "Good evening. Today we have tested the book 😊 and the test was successful! 😊 He didn't want to leave it. Thank you.",
      other : "Олеся, добрый вечер! Сегодня проводили испытания 😊 все прошло отлично 😊 расставаться не хотел.",
      location : "Sweden"
    },
    {
      number: 3,
      name: "Jenny",
      lang: "SV",
      eng : "We have our book on the car right now and I'm not always with them, when they go somewhere, that is why I don't know what does he do with the book. But yesterday I was going with them and son demanded his book right away and was playing with it very nice (but there are some separated details that usually fall down :) so one should open the car door carefully :))",
      other : "Vi har boken i bilen just nu och oftast är jag inte med när de åker därför ser jag inte vad han gör. Men igår var jag med och han ville ha på en gång och lekte fint (förutom att han slängde bort några saker, det brukar han göra, så man måste vara försiktig när man öppnar dörren sedan ;))",
      location : "Sweden"
    },
    {
      number: 4,
      name: "Mpbaa",
      eng : "Just wanted to let you know my Son (and we) love your book. It is beautifully made. Thank you so much!",
      location : "The Netherlands",
      img: "Ryboolba" // if no customer picture - use cover image
    }
  ],
  all: function() { return this.feedbacks },
  get: function(id) {
    const isPlayer = p => p.number === id
    return this.players.find(isPlayer)
  }
}

export default DataFeedbacks



// WEBPACK FOOTER //
// ./src/components/API_Feedbacks.js